// extracted by mini-css-extract-plugin
export default {"container":"view-answer-quotation-modal_container__4SnjM","actions":"view-answer-quotation-modal_actions__8p38c","confirm-btn":"view-answer-quotation-modal_confirm-btn__XbVLg"};